import { INVESTMENT_PROFILE_TYPE_ENTITY } from "@components/Domain"


const isEntityInvestment = ({ profileType }) => {
  return profileType === INVESTMENT_PROFILE_TYPE_ENTITY
}

export default isEntityInvestment
